<template>
  <div>
    <vs-row class="my-4">
      <vs-col
        ><h5><i class="dot"></i>기본정보</h5></vs-col
      >
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">회사명</div>
        <span v-if="isPrint"> {{form.inputA_1}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_1" :readonly="true"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">소속</div>
        <span v-if="isPrint"> {{form.inputA_5}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_5" :readonly="true"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">부서</div>
        <span v-if="isPrint"> {{form.inputA_2}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_2" :readonly="true"/>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작성자</div>
        <span v-if="isPrint"> {{form.inputA_3}} </span>
          <ml-input v-else class="w-full flex-1" v-model="form.inputA_3" :readonly="true"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작성일</div>
        <span v-if="isPrint"> {{form.inputA_4}} </span>
        <date-selector v-else class="w-full flex-1" v-model="form.inputA_4" :readonly="board.readonly"/>
      </div>
    </div>
    <vs-row class="my-4">
      <vs-col
        ><h5><i class="dot"></i>관련 근거 및 요청일시</h5></vs-col
      >
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-12 flex items-center">
        <div class="label-text mr-4">관련 근거</div>
        <span v-if="isPrint"> {{form.inputB_1}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputB_1" :readonly="board.readonly"/>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">요청일시</div>
        <span v-if="isPrint"> {{form.inputB_2}} </span>
        <date-selector v-else class="w-full flex-1" v-model="form.inputB_2" :readonly="board.readonly"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">요청시간</div>
        <span v-if="isPrint"> {{form.inputB_3}} </span>
        <time-selector v-else class="w-full flex-1" v-model="form.inputB_3" :readonly="board.readonly"/>
      </div>
    </div>
    <vs-row class="my-4">
      <vs-col
        ><h5><i class="dot"></i>요청자</h5></vs-col
      >
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">소속</div>
        <span v-if="isPrint"> {{form.inputC_1}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputC_1" :readonly="board.readonly"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">직위</div>
        <span v-if="isPrint"> {{form.inputC_2}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputC_2" :readonly="board.readonly"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">성명</div>
        <span v-if="isPrint"> {{form.inputC_3}} </span>
          <ml-input v-else class="w-full flex-1" v-model="form.inputC_3" :readonly="board.readonly"/>
      </div>
    </div>
    <vs-row class="my-4">
      <vs-col
        ><h5><i class="dot"></i>요청내용</h5></vs-col
      >
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">위험요인 및 중지요청 작업</div>
        <span v-if="isPrint"> {{form.inputD_1}} </span>
        <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputD_1" :readonly="board.readonly"/>
      </div>
    </div>
    <vs-row class="my-4">
      <vs-col
        ><h5><i class="dot"></i>현장조사</h5></vs-col
      >
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">조사결과</div>
        <span v-if="isPrint"> {{form.inputE_1}} </span>
        <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputE_1" :readonly="board.readonly"/>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-12 flex items-center">
        <div class="label-text mr-4">타당여부</div>
        <span v-if="isPrint"> {{form.inputE_2}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputE_2" :readonly="board.readonly"/>
      </div>
    </div>
    <vs-row class="my-4">
      <vs-col
        ><h5><i class="dot"></i>조치결과</h5></vs-col
      >
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업중지 명령</div>
        <span v-if="isPrint"> {{form.inputF_1}} </span>
        <date-selector v-else class="w-full flex-1" v-model="form.inputF_1" :readonly="board.readonly"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업중지 시간</div>
        <span v-if="isPrint"> {{form.inputF_2}} </span>
        <time-selector v-else class="w-full flex-1" v-model="form.inputF_2" :readonly="board.readonly"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장소</div>
        <span v-if="isPrint"> {{form.inputF_3}} </span>
          <ml-input v-else class="w-full flex-1" v-model="form.inputF_3" :readonly="board.readonly"/>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">개선조치</div>
        <span v-if="isPrint"> {{form.inputF_4}} </span>
        <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputF_4" :readonly="board.readonly"/>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">완료일시</div>
        <span v-if="isPrint"> {{form.inputF_5}} </span>
        <date-selector v-else class="w-full flex-1" v-model="form.inputF_5" :readonly="board.readonly"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">완료시간</div>
        <span v-if="isPrint"> {{form.inputF_6}} </span>
        <time-selector v-else class="w-full flex-1" v-model="form.inputF_6" :readonly="board.readonly"/>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-12 flex items-center">
        <div class="label-text mr-4">작업재개</div>
        <span v-if="isPrint"> {{form.inputG_1}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputG_1" :readonly="board.readonly"/>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">재발방지대책</div>
        <span v-if="isPrint"> {{form.inputG_2}} </span>
        <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputG_2" :readonly="board.readonly"/>
      </div>
    </div>
    <file-upload-module class="w-full" v-if="!isPrint" v-model="form.fileList" :readonly="board.readonly"/>
  </div>
</template>

<script>
  import DateSelector from '@/components/selector/DateSelector'
  import TimeSelector from '@/components/selector/TimeSelector'
  import FileUploadModule from '@/views/modules/FileUploadModule'
export default {
  name: "Write",
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inputA_1 = this.value && this.value.inputA_1 ? this.value.inputA_1 : this.board.projectTitle
        this.form.inputA_2 = this.value && this.value.inputA_2 ? this.value.inputA_2 : this.board.writer.com_name
        this.form.inputA_3 = this.value && this.value.inputA_3 ? this.value.inputA_3 : this.board.writer.name
        this.form.inputA_5 = this.value && this.value.inputA_5 ? this.value.inputA_5 : this.board.writer.department
      }
    },
    value(value) {
      const keys = Object.keys(this.form)
      for (const key of keys) {
        this.form[key] = value[key]
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = value.inputA_1
        this.$emit('input', value);
      }
    }
  },
  data () {
    return {
      form: {
        inputA_1:'',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '',
        inputB_1:'',
        inputB_2:'',
        inputB_3:'',
        inputC_1:'',
        inputC_2:'',
        inputC_3:'',
        inputD_1:'',
        inputE_1:'',
        inputE_2:'',
        inputF_1:'',
        inputF_2:'',
        inputF_3:'',
        inputF_4:'',
        inputF_5:'',
        inputF_6:'',
        inputG_1: '',
        inputG_2: '',
        fileList: []
      }
    }
  },
  components: { DateSelector, TimeSelector, FileUploadModule },
};
</script>

<style scoped>
  .label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  margin-right: 16px;
  }
  .mt-component-form {
    margin-top: 20px;
  }
  .grid {
    padding-top: 1rem;
  }
</style>
